// flowgenIgnore
function camelizeString(snakeString = ''): string {
  return snakeString
    .trim()
    .replace(/(-|_|\s)+(.)?/g, (_match, _sep, c) => (c ? c.toUpperCase() : ''));
}

function camelize(
  snakeData: Record<string, unknown> = {},
  recursive = false,
  blocklist: string[] = []
): Record<string, unknown> {
  const camelData = Array.isArray(snakeData) ? [] : {};
  Object.keys(snakeData).forEach((key) => {
    const camelKey = blocklist.includes(key) ? key : camelizeString(key);
    const data = snakeData[key];
    if (recursive && data && typeof data === 'object') {
      camelData[camelKey] = camelize(data as Record<string, unknown>, true, blocklist);
    } else {
      camelData[camelKey] = data;
    }
  });
  return camelData;
}

function snakeifyString(camelString = ''): string {
  return camelString
    .trim()
    .replace(/([a-z\d])([A-Z]+)/g, '$1_$2')
    .replace(/([A-Z\d]+)([A-Z][a-z])/g, '$1_$2')
    .replace(/[-\s]+/g, '_')
    .toLowerCase();
}

function snakeify(
  camelData: Record<string, unknown> = {},
  recursive = false
): Record<string, unknown> {
  const snakeData = Array.isArray(camelData) ? [] : {};
  Object.keys(camelData).forEach((key) => {
    const snakeKey = snakeifyString(key);
    const data = camelData[key];
    if (recursive && data && typeof data === 'object') {
      snakeData[snakeKey] = snakeify(data as Record<string, unknown>, true);
    } else {
      snakeData[snakeKey] = data;
    }
  });
  return snakeData;
}

function kebabifyString(camelString = ''): string {
  return camelString
    .trim()
    .replace(/([a-z\d])([A-Z]+)/g, '$1-$2')
    .replace(/([A-Z\d]+)([A-Z][a-z])/g, '$1-$2')
    .replace(/[_\s]+/g, '-')
    .toLowerCase();
}

export { camelize, snakeify, camelizeString, snakeifyString, kebabifyString };



// WEBPACK FOOTER //
// ../utilities/object-utilities.ts